import { StyleProps } from "@chakra-ui/react"

import { $g1Color } from "@/theme/G1Style";
import { CustomItemType } from "@utils/TypesAndConstants";

export const useStyles = () => {
    const cloudsSectionStyle: StyleProps = {
        bg: $g1Color('list.clouds.bg'),
        color: $g1Color('list.clouds.write'),
        fontWeight: "bold",
        overflow: "hidden",
        rounded: "xl",
        width: "100%",
    } ;

    const cloudItemStyle: CustomItemType = {
        borderTop: "1px",
        borderTopColor: $g1Color('list.spacer'),
        iconColor: $g1Color('list.icon'),
        hover: { bg: $g1Color('list.clouds.hover.bg'), color: $g1Color('list.clouds.hover.write') },
        select: { bg: $g1Color('list.clouds.select.bg'), color: $g1Color('list.clouds.select.write') }
    } ;

    const contactsSectionStyle: StyleProps = {
        bg: $g1Color('list.contacts.bg'),
        color: $g1Color('list.contacts.write'),
        fontWeight: "bold",
        overflow: "hidden",
        rounded: "xl",
        width: "100%",
    };
    const contactItemStyle: CustomItemType = {
        borderTop: "1px",
        borderTopColor: $g1Color('list.spacer'),
        iconColor: $g1Color('list.icon'),
        hover: { bg: $g1Color('list.contacts.hover.bg'), color: $g1Color('list.contacts.hover.write') },
        select: { bg: $g1Color('list.contacts.select.bg'), color: $g1Color('list.contacts.select.write') },
    };

    const corporationsSectionStyle: StyleProps = {
        bg: $g1Color('list.corporations.bg'),
        color: $g1Color('list.corporations.write'),
        fontWeight: "bold",
        overflow: "hidden",
        rounded: "xl",
        width: "100%",
    };
    const corporationItemStyle: CustomItemType = {
        borderTop: "1px",
        borderTopColor: $g1Color('list.spacer'),
        iconColor: $g1Color('list.icon'),
        hover: { bg: $g1Color('list.corporations.hover.bg'), color: $g1Color('list.corporations.hover.write') },
        select: { bg: $g1Color('list.corporations.select.bg'), color: $g1Color('list.corporations.select.write') },
    };

    const documentsSectionStyle: StyleProps = {
        bg: $g1Color('list.documents.bg'),
        color: $g1Color('list.documents.write'),
        fontWeight: "bold",
        overflow: "hidden",
        rounded: "xl",
        width: "100%",
    } ;

    const documentItemStyle: CustomItemType = {
        borderTop: "1px",
        borderTopColor: $g1Color('list.spacer'),
        iconColor: $g1Color('list.icon'),
        hover: { bg: $g1Color('list.documents.hover.bg'), color: $g1Color('list.documents.hover.write') },
        select: { bg: $g1Color('list.documents.select.bg'), color: $g1Color('list.documents.select.write') },
    } ;

    const expeditorsSectionStyle: StyleProps = {
        ...contactsSectionStyle,
        bg: $g1Color('list.expeditors.bg'),
        color: $g1Color('list.expeditors.write'),
    };
    const expeditorItemStyle: CustomItemType = {
        borderTop: "1px",
        borderTopColor: $g1Color('list.spacer'),
        iconColor: $g1Color('list.icon'),
        hover: { bg: $g1Color('list.expeditors.hover.bg'), color: $g1Color('list.expeditors.hover.write') },
        select: { bg: $g1Color('list.expeditors.select.bg'), color: $g1Color('list.expeditors.select.write') },
    };

    const templatesSectionStyle: StyleProps = {
        bg: $g1Color('list.templates.bg'),
        color: $g1Color('list.templates.write'),
        fontWeight: "bold",
        overflow: "hidden",
        rounded: "xl",
        width: "100%",
    };

    const templateItemStyle: CustomItemType = {
        borderTop: "1px",
        borderTopColor: $g1Color('list.spacer'),
        iconColor: $g1Color('list.icon'),
        hover: { bg: $g1Color('list.templates.hover.bg'), color: $g1Color('list.templates.hover.write') },
        select: { bg: $g1Color('list.templates.select.bg'), color: $g1Color('list.templates.select.write') },
    }

    const usersSectionStyle: StyleProps = {
        bg: $g1Color('list.contacts.bg'),
        color: $g1Color('list.contacts.write'),
        fontWeight: "bold",
        overflow: "hidden",
        rounded: "xl",
        width: "100%",
    }
    const userItemStyle: CustomItemType = {
        borderTop: "1px",
        borderTopColor: $g1Color('list.spacer'),
        iconColor: $g1Color('list.icon'),
        hover: { bg: $g1Color('list.contacts.hover.bg'), color: $g1Color('list.contacts.hover.write') },
        select: { bg: $g1Color('list.contacts.select.bg'), color: $g1Color('list.contacts.select.write') },
    }

    return { 
        sectionStyle: {
            clouds: cloudsSectionStyle,
            contacts: contactsSectionStyle,
            corporations: corporationsSectionStyle,
            documents: documentsSectionStyle,
            expeditors: expeditorsSectionStyle,
            signers: contactsSectionStyle,
            templates: templatesSectionStyle,
            users: usersSectionStyle,
        },
        itemStyle: {
            cloud: cloudItemStyle,
            contact: contactItemStyle,
            corporation: corporationItemStyle,
            document: documentItemStyle,
            expeditor: expeditorItemStyle,
            signer: contactItemStyle,
            template: templateItemStyle,
            user: userItemStyle
        }
    };
}